module.exports = __webpack_public_path__ + "img/p2-84.9613ebd7.png";